import { SgvJson } from '@eceos/arch';

export class CalculatedValue {
  constructor(public value: number = 0, public calculated: boolean = true) {}

  isValid(): boolean {
    return this.value != null && this.value >= 0;
  }

  toJson(): any {
    return SgvJson.to.simple(this);
  }

  static fromJson(json: any): CalculatedValue {
    return json ? SgvJson.from.simple(json, CalculatedValue) : null;
  }
}
